export default __webpack_public_path__ + "294ff219dac289f8a66229d9e4cc35aa.png";